import { render } from "./ActionDisplayFreePopup.vue?vue&type=template&id=772748e0"
import script from "./ActionDisplayFreePopup.vue?vue&type=script&lang=ts"
export * from "./ActionDisplayFreePopup.vue?vue&type=script&lang=ts"
script.render = render

export default script